import dayjs from 'dayjs'
import 'dayjs/locale/en.js'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './en/en.json'
import es from './es/esp.json'

export const DEFAULT_LANG = 'en'

export const DEFAULT_VARIABLES = {
  UFarm: 'UFarm Digital',
}

export const listOfTranslations = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
}

const params = new URLSearchParams(document.location.search)
const language = params.get('language')

i18n.use(initReactI18next).init({
  debug: false,
  defaultNS: 'translation',
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    defaultVariables: {
      ...DEFAULT_VARIABLES,
      escapeValue: false,
    },
  },
  lng: language || window.navigator.language || window.navigator.userLanguage,
  load: 'currentOnly',
  ns: ['translation'],
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'em', 's', 'b', 'a', 'span'],
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
  },
  resources: {
    ...listOfTranslations,
  },
  returnEmptyString: false,
  returnNull: false,
  returnObjects: true,
  supportedLngs: ['en', 'es'],
})

dayjs.locale(i18n.resolvedLanguage)

export default i18n
